module.exports = {"410183001":"青屏街街道","410183002":"新华路街道","410183003":"西大街街道","410183100":"城关镇","410183101":"米村镇","410183102":"牛店镇","410183103":"平陌镇","410183104":"超化镇","410183105":"苟堂镇","410183106":"大隗镇","410183107":"刘寨镇","410183108":"白寨镇","410183109":"岳村镇","410183110":"来集镇","410183113":"曲梁镇","410183200":"袁庄乡","410183400":"矿区街道","410183401":"伏羲山风景区管理委员会","410183402":"郑州曲梁产业集聚区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410183.json
// module id = 1644
// module chunks = 0